export default __webpack_public_path__ + "static/media/logo.1760cc83.png";